import {
  BibliographySearchNarrowCondition,
  BibliographySearchNarrowConditionToJSON,
  SystemCode
} from '@/api'

import {
  CollectionTarget,
  SearchTarget,
  DisplayMethod,
  SearchType,
  BibliographyClass,
  BibliographySearchSortOrder,
  BibliographySearchSortKey
} from '@/types'

export interface BibliographySearchRequest {
  displayMethod: DisplayMethod
  searchTarget: SearchTarget
  numberOfLimit: number
  searchMethodAnd: boolean
  searchMethodSynonym: boolean
  searchMethodAllograph: boolean
  andSearchType: SearchType[]
  andCollectionTarget: CollectionTarget[]
  andMaterialFormat: string[]
  andBibliographyClass: BibliographyClass[]
  displayBranchCode: SystemCode
  bibliography: {
    title1: string
    title1Not: boolean
    title2: string
    title2Not: boolean
    titleInformation: boolean
    author1: string
    author1No: string
    author1Not: boolean
    author2: string
    author2No: string
    author2Not: boolean
    authorNos: string[]
    authorInformation: boolean
    subject1: string
    subject1No: string
    subject1Not: boolean
    subject2: string
    subject2No: string
    subject2Not: boolean
    subjectNos: string[]
    completeWorks: string
    completeWorksNo: string
    completeWorksNot: boolean
    completeWorksNos: string[]
    series: string
    seriesNo: string
    seriesNot: boolean
    seriesNos: string[]
    note: string
    publisher: string
    publisherNo: string
    publisherNot: boolean
    publisherNos: string[]
    volumeLabel: string
    volumeLabelNot: boolean
    classNo: string
    publishedYearFrom: string
    publishedYearTo: string
    playbackTimeFrom: string
    playbackTimeTo: string
    volume: string
    volumeNumber: string
    volumeTotal: string
    dateLabel: string
    genres: string[]
    targetUsers: string[]
    targetUsersAv: string[]
  }
  collection: {
    collectionTypes: string[]
    shelfTypes: string[]
    callNumberMark: string
    callNumberNdc: string
    callNumberBook: string
    callNumberSub: string
    traderCodes: string[]
    donorCodes: string[]
    collectionStatus: string[]
    collectionStatusRemove: boolean
    holdingBranchCodes: string[]
    orderStatus: string[]
    orderBranchCodes: string[]
    acceptDateFrom: string
    acceptDateTo: string
    handlingTypes: string[]
    lendTotal: string
    lendTotalFlag: string
    lastLendDate: string
    lastLendDateFlag: string
  }
  narrow: BibliographySearchNarrowCondition
  sortKey: BibliographySearchSortKey
  sortOrder: BibliographySearchSortOrder
  page?: number
  _saveHistory?: boolean
}

export function BibliographySearchRequestToJSON(
  value: BibliographySearchRequest
): any {
  return {
    display_method: value.displayMethod,
    search_target: value.searchTarget,
    number_of_limit:
      value.numberOfLimit !== 0 ? value.numberOfLimit : undefined,
    search_method_and: value.searchMethodAnd ?? undefined,
    search_method_synonym: value.searchMethodSynonym ?? undefined,
    search_method_allograph: value.searchMethodAllograph ?? undefined,
    and_search_type:
      value.searchMethodAnd && value.andSearchType.length !== 0
        ? value.andSearchType
        : undefined,
    and_collection_target:
      value.searchMethodAnd && value.andCollectionTarget.length !== 0
        ? value.andCollectionTarget
        : undefined,
    and_material_format:
      value.searchMethodAnd && value.andMaterialFormat.length !== 0
        ? value.andMaterialFormat
        : undefined,
    and_bibliography_class:
      value.searchMethodAnd && value.andBibliographyClass.length !== 0
        ? value.andBibliographyClass
        : undefined,
    display_branch_code:
      value.displayBranchCode.code !== ''
        ? value.displayBranchCode.code
        : undefined,
    bibliography: {
      title1:
        value.bibliography.title1 !== ''
          ? value.bibliography.title1
          : undefined,
      title1_not:
        value.bibliography.title1 !== ''
          ? value.bibliography.title1Not
          : undefined,
      title2:
        value.bibliography.title2 !== ''
          ? value.bibliography.title2
          : undefined,
      title2_not:
        value.bibliography.title2 !== ''
          ? value.bibliography.title2Not
          : undefined,
      title_information:
        value.bibliography.title1 !== '' || value.bibliography.title2 !== ''
          ? value.bibliography.titleInformation
          : undefined,
      author1:
        value.bibliography.author1 !== '' && value.bibliography.author1No === ''
          ? value.bibliography.author1
          : undefined,
      author1_no:
        value.bibliography.author1No !== ''
          ? value.bibliography.author1No
          : undefined,
      author1_not:
        value.bibliography.author1 !== '' || value.bibliography.author1No !== ''
          ? value.bibliography.author1Not
          : undefined,
      author2:
        value.bibliography.author2 !== '' && value.bibliography.author2No === ''
          ? value.bibliography.author2
          : undefined,
      author2_no:
        value.bibliography.author2No !== ''
          ? value.bibliography.author2No
          : undefined,
      author2_not:
        value.bibliography.author2 !== '' || value.bibliography.author2No !== ''
          ? value.bibliography.author2Not
          : undefined,
      author_information:
        value.bibliography.author1 !== '' ||
        value.bibliography.author2 !== '' ||
        value.bibliography.author1No !== '' ||
        value.bibliography.author2No !== ''
          ? value.bibliography.authorInformation
          : undefined,
      author_nos:
        value.bibliography.authorNos.length > 0
          ? value.bibliography.authorNos
          : undefined,
      subject1:
        value.bibliography.subject1 !== '' &&
        value.bibliography.subject1No === ''
          ? value.bibliography.subject1
          : undefined,
      subject1_no:
        value.bibliography.subject1No !== ''
          ? value.bibliography.subject1No
          : undefined,
      subject1_not:
        value.bibliography.subject1 !== '' ||
        value.bibliography.subject1No !== ''
          ? value.bibliography.subject1Not
          : undefined,
      subject2:
        value.bibliography.subject2 !== '' &&
        value.bibliography.subject2No === ''
          ? value.bibliography.subject2
          : undefined,
      subject2_no:
        value.bibliography.subject2No !== ''
          ? value.bibliography.subject2No
          : undefined,
      subject2_not:
        value.bibliography.subject2 !== '' ||
        value.bibliography.subject2No !== ''
          ? value.bibliography.subject2Not
          : undefined,
      subject_nos:
        value.bibliography.subjectNos.length > 0
          ? value.bibliography.subjectNos
          : undefined,
      series:
        value.bibliography.series !== '' && value.bibliography.seriesNo === ''
          ? value.bibliography.series
          : undefined,
      series_no:
        value.bibliography.seriesNo !== ''
          ? value.bibliography.seriesNo
          : undefined,
      series_not:
        value.bibliography.series !== '' || value.bibliography.seriesNo !== ''
          ? value.bibliography.seriesNot
          : undefined,
      series_nos:
        value.bibliography.seriesNos.length > 0
          ? value.bibliography.seriesNos
          : undefined,
      complete_works:
        value.bibliography.completeWorks !== '' &&
        value.bibliography.completeWorksNo === ''
          ? value.bibliography.completeWorks
          : undefined,
      complete_works_no:
        value.bibliography.completeWorksNo !== ''
          ? value.bibliography.completeWorksNo
          : undefined,
      complete_works_not:
        value.bibliography.completeWorks !== '' ||
        value.bibliography.completeWorksNo !== ''
          ? value.bibliography.completeWorksNot
          : undefined,
      complete_works_nos:
        value.bibliography.completeWorksNos.length > 0
          ? value.bibliography.completeWorksNos
          : undefined,
      note:
        value.bibliography.note !== '' ? value.bibliography.note : undefined,
      publisher:
        value.bibliography.publisher !== '' &&
        value.bibliography.publisherNo === ''
          ? value.bibliography.publisher
          : undefined,
      publisher_no:
        value.bibliography.publisherNo !== ''
          ? value.bibliography.publisherNo
          : undefined,
      publisher_not:
        value.bibliography.publisher !== '' ||
        value.bibliography.publisherNo !== ''
          ? value.bibliography.publisherNot
          : undefined,
      publisher_nos:
        value.bibliography.publisherNos.length > 0
          ? value.bibliography.publisherNos
          : undefined,
      volume_label:
        value.bibliography.volumeLabel !== ''
          ? value.bibliography.volumeLabel
          : undefined,
      volume_label_not:
        value.bibliography.volumeLabel !== ''
          ? value.bibliography.volumeLabelNot
          : undefined,
      class_no:
        value.bibliography.classNo !== ''
          ? value.bibliography.classNo
          : undefined,
      published_year_from:
        value.bibliography.publishedYearFrom !== ''
          ? value.bibliography.publishedYearFrom
          : undefined,
      published_year_to:
        value.bibliography.publishedYearTo !== ''
          ? value.bibliography.publishedYearTo
          : undefined,
      playback_time_from:
        value.bibliography.playbackTimeFrom !== ''
          ? value.bibliography.playbackTimeFrom
          : undefined,
      playback_time_to:
        value.bibliography.playbackTimeTo !== ''
          ? value.bibliography.playbackTimeTo
          : undefined,
      volume:
        value.bibliography.volume !== ''
          ? value.bibliography.volume
          : undefined,
      volume_number:
        value.bibliography.volumeNumber !== ''
          ? value.bibliography.volumeNumber
          : undefined,
      volume_total:
        value.bibliography.volumeTotal !== ''
          ? value.bibliography.volumeTotal
          : undefined,
      date_label:
        value.bibliography.dateLabel !== ''
          ? value.bibliography.dateLabel
          : undefined,
      genres:
        value.bibliography.genres.length !== 0
          ? value.bibliography.genres
          : undefined,
      target_users:
        value.bibliography.targetUsers.length !== 0
          ? value.bibliography.targetUsers
          : undefined,
      target_users_av:
        value.bibliography.targetUsersAv.length !== 0
          ? value.bibliography.targetUsersAv
          : undefined
    },
    collection: {
      collection_types:
        value.collection.collectionTypes.length !== 0
          ? value.collection.collectionTypes
          : undefined,
      shelf_types:
        value.collection.shelfTypes.length !== 0
          ? value.collection.shelfTypes
          : undefined,
      call_number_mark:
        value.collection.callNumberMark !== ''
          ? value.collection.callNumberMark
          : undefined,
      call_number_ndc:
        value.collection.callNumberNdc !== ''
          ? value.collection.callNumberNdc
          : undefined,
      call_number_book:
        value.collection.callNumberBook !== ''
          ? value.collection.callNumberBook
          : undefined,
      call_number_sub:
        value.collection.callNumberSub !== ''
          ? value.collection.callNumberSub
          : undefined,
      trader_codes:
        value.collection.traderCodes.length !== 0
          ? value.collection.traderCodes
          : undefined,
      donor_codes:
        value.collection.donorCodes.length !== 0
          ? value.collection.donorCodes
          : undefined,
      collection_status:
        value.collection.collectionStatus.length !== 0
          ? value.collection.collectionStatus
          : undefined,
      collection_status_remove: value.collection.collectionStatusRemove,
      holding_branch_codes:
        value.collection.holdingBranchCodes.length !== 0
          ? value.collection.holdingBranchCodes
          : undefined,
      order_status:
        value.collection.orderStatus.length !== 0
          ? value.collection.orderStatus
          : undefined,
      order_branch_codes:
        value.collection.orderBranchCodes.length !== 0
          ? value.collection.orderBranchCodes
          : undefined,
      accept_date_from:
        value.collection.acceptDateFrom !== ''
          ? value.collection.acceptDateFrom
          : undefined,
      accept_date_to:
        value.collection.acceptDateTo !== ''
          ? value.collection.acceptDateTo
          : undefined,
      handling_types:
        value.collection.handlingTypes.length !== 0
          ? value.collection.handlingTypes
          : undefined,
      lend_total:
        value.collection.lendTotal !== ''
          ? value.collection.lendTotal
          : undefined,
      lend_total_flag:
        value.collection.lendTotal !== '' &&
        value.collection.lendTotalFlag !== ''
          ? value.collection.lendTotalFlag
          : undefined,
      last_lend_date:
        value.collection.lastLendDate !== ''
          ? value.collection.lastLendDate
          : undefined,
      last_lend_date_flag:
        value.collection.lastLendDate !== '' &&
        value.collection.lastLendDateFlag !== ''
          ? value.collection.lastLendDateFlag
          : undefined
    },
    narrow: BibliographySearchNarrowConditionToJSON(value.narrow),
    sort_key: value.sortKey !== '' ? value.sortKey : undefined,
    sort_order: value.sortOrder !== '' ? value.sortOrder : undefined,
    page: value.page ?? undefined,
    _save_history: value._saveHistory ?? undefined
  }
}
